import { Box, styled } from "@mui/material";

export const HeaderRow = styled(Box)(({
  theme
}) => ({
  display: "grid",
  gridTemplateColumns: '40% 60%',
  gap: theme.spacing(1),
  justifyContent: "center",
  alignItems: "center",
  marginBottom: theme.spacing(2),
}));

export const ButtonBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  '& #btn_publish_quarters': {
    marginRight: theme.spacing(1)
  }
}));

export const CellBox = styled(Box)(() => ({
  width: '100%'
}));